








































































import ComponentSelector from "../Selectors/ComponentSelector.vue";
import { Component, Vue, Prop } from "vue-property-decorator";
import { ppm } from "../../api/ppm/ppm";
import { group } from "../../api/group/group";
import { component } from "../../api/component/component";
import { status } from "../../api/status/status";
import { new_project } from "../../api/new_project/new_project"
import Moment from "moment";

@Component({
  name: "PPMFilters2",
  props: {
    filters: { 
      project_title: "",
      fromDate: "",
      toDate: "",     
    }
  },
  model: {
    prop: "filters",
    event: "change"
  }
  // ,
  //  watch: {
  //   date: function(val) {
  //     this.$props.filters.fromDate = val;
  //   }
  // }
})
export default class WorkOrderFilters extends Vue {
  public sectorsList: any[] = [];
  public placesList: any[] = [];
  public titlesList: any[] = [];

  public loading: boolean = false;
  public activeName: any = "1";
  public systems: any[] = [];
  public componentList: any[] = [];
  public visibleComponents: any[] = [];
  public statuses: any[] = [];
  public maintenancePeriodOptions: any[] = [];
  public maintenancePeriod: any = ''; 
  public date: Date = new Date();
  //  public update() {
  //   this.$forceUpdate();
  // }
  public async mounted() {
    this.loading = true;

   
    await this.getProjectTitlesList();
    // this.$props.filters.fromDate = new Date(
    //   new Date().setDate(new Date().getDate() - 10)
    // );
    //this.date = new Date(new Date().setDate(new Date().getDate() - 10));
    // this.loading = false;
  }
 
   
public async getProjectTitlesList(){
    await new_project
    .getProjectTitles(
    this.$store.getters.getToken,
    this.$store.getters.getHost
    )
    .then(response => {
    response.json().then(resp => {
    let i = 0;
    while (i <= JSON.parse(JSON.stringify(resp)).length - 1) {
      this.titlesList.push({
        value: JSON.parse(JSON.stringify(resp))[i].id,
        label: JSON.parse(JSON.stringify(resp))[i].literal
        });
         i++;
       }
       console.log('testforprojectplaces-------->'+JSON.stringify(resp))
      });
    });   
  }
 



}
